import {
  useCallback,
  useEffect,
  useRef,
} from 'react'

/**
 * Call a given function after a set delay.
 * @param {function} callback - the function to call
 * @param {number} delay - the time to wait before calling
 */
const useDebouncedFn = (callback, delay) => {
  const timeoutRef = useRef(null)

  const debouncedFunction = useCallback(
    (...args) => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }
      timeoutRef.current = setTimeout(() => {
        callback(...args)
      }, delay)
    },
    [callback, delay],
  )

  useEffect(() => () => {
    // handle unmount
    if (timeoutRef.current !== null) clearTimeout(timeoutRef.current)
  }, [])

  return debouncedFunction
}

export default useDebouncedFn
